import styles from './lotOption.module.css'
import { useEffect, useState } from "react"
import { Lot, Product } from "../../.."
import { useStockHooks } from "../../../../stock"
import { useManagerHooks } from "../../../../manager"

type Props = {
    product: Product
    lot: Lot
    branchId?: string
    onClick?: (e: React.MouseEvent<HTMLElement>) => void
}

export const LotOption = (props: Props) => {
    const { product, lot, branchId, onClick } = props

    const [stockInfo, setStockInfo] = useState<string>()

    const { currentBranchId } = useManagerHooks()
    const { describeAvailableStock } = useStockHooks()

    useEffect(() => {
        describeAvailableStock(product!, branchId || currentBranchId!, lot.id).then(setStockInfo)
    }, [product.id, branchId, lot.id])

    const stockClassName = `${styles.stock} ${stockInfo?.startsWith('0') ? styles.noStock : ''}`

    return (
        <div className={styles.container} onClick={onClick}>
            {lot.code}
            <span className={stockClassName}>
                {stockInfo}
            </span>
        </div>
    )
}
